import { Navigate, useSearchParams } from "react-router-dom";
import { LoadingFailedPage, LoadingPage } from "~/components/loading";
import { OrganizationScope, SpaceScope } from "~/hooks/useScope";
import { useGetClientIntegrationQuery } from "~/operations";
import { INTEGRATION_MRN } from "~/pages/integrations/utils/integrationConstants";
import { integrationDetailHref } from "~/pages/integrations/utils/integrationLinksUtils";

export interface IntegrationDetailMrnProps {
  scope: SpaceScope | OrganizationScope;
}

export function IntegrationDetailMrnPage({ scope }: IntegrationDetailMrnProps) {
  const [searchParams] = useSearchParams();
  const integrationMrn = searchParams.get(INTEGRATION_MRN);

  const { data, loading, error } = useGetClientIntegrationQuery({
    variables: { mrn: integrationMrn || "skip" },
    skip: !integrationMrn,
  });

  if (loading) {
    return <LoadingPage what="Integration" />;
  }

  const integration = data?.clientIntegration.integration;

  if (error || !integration) {
    return <LoadingFailedPage what="Integration" />;
  }

  return (
    <Navigate
      to={integrationDetailHref(integration.type, integration.mrn, scope)}
      replace
    />
  );
}
